<div class="form-step">
  @if (name()) {
    <h3>{{ name() | transloco }}</h3>
  }
  <ng-content></ng-content>
</div>
